export enum LdKpiMetric {
  CorrelationsNew = 'correlations_new',
  CorrelationsTotal = 'correlations_total',
  PredictionPossible = 'prediction_possible',
  PredictionProbable = 'prediction_probable',
}
